import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      La Vulkanoj havas multe da varmo, kiun ili hastas rapide fordoni, kaj tial eruptas ĝin, bruligante, sed ne varmigante la apudaĴon.
    </p>
    
    <p class="mb-3">
      Ja ankaŭ por fordoni varmecon, bezonatas scipovo. 
      Por ke la bonaj intencoj ne fariĝu kataklismoj.
    </p>
  `
  )
}

const itemName = {
  esp: 'La vulkanoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;